// 协议客户接口
import fetch from '../plugin/axios/fetch_protocol'

export async function checkPostMoneyCodeApi (data) {
  const res = await fetch.post({
    url: '/preOrder/checkPostMoneyCode',
    data
  })
  return res.data
}

// 服务推荐查询产品
export async function queryServiceRecommendApi (data) {
  const res = await fetch.post({
    url: '/preOrder/queryServiceRecommend',
    data
  })
  return res.data
}

// 查询网点
export async function findNearbyOfficeApi (data) {
  const res = await fetch.post({
    url: '/preOrder/findNearbyOffice',
    data
  })
  return res.data
}
